var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.3726 5.3726 0 12 0C18.6274 0 24 5.3726 24 12C24 18.6274 18.6274 24 12 24C5.3726 24 0 18.6274 0 12Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13471 7.39853C9.13471 8.17595 8.52962 8.798 7.55803 8.798H7.5402C6.60478 8.798 6 8.17595 6 7.39853C6 6.60466 6.62317 6 7.57637 6C8.52962 6 9.11662 6.60466 9.13471 7.39853ZM8.95115 9.90312V17.9998H6.16476V9.90312H8.95115ZM18.9999 17.9998L19 13.3574C19 10.8705 17.6254 9.71301 15.7918 9.71301C14.3124 9.71301 13.65 10.4989 13.2802 11.0502V9.90337H10.4935C10.5302 10.6631 10.4935 18 10.4935 18H13.2802V13.4781C13.2802 13.2362 13.2983 12.9948 13.372 12.8215C13.5734 12.3381 14.0319 11.8376 14.8017 11.8376C15.8104 11.8376 16.2136 12.58 16.2136 13.6681V17.9998H18.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cc3ba0e51608aae67a88e182e2d43191.svg";
export { ForwardRef as ReactComponent };